import { apiClient } from './client';
import type { 
  BatteriesResponse, 
  BatteryResponse, 
  SearchResponse,
  LowStockResponse 
} from '@/types';

export const batteriesAPI = {
  getAll: (params?: any) =>
    apiClient.get<BatteriesResponse>('/batteries', { params }),

  getById: (id: number) =>
    apiClient.get<BatteryResponse>(`/batteries/${id}`),

  search: (query: string, limit = 10) =>
    apiClient.get<SearchResponse>('/batteries/search', {
      params: { q: query, limit }
    }),

  getLowStock: (filter = 'all') =>
    apiClient.get<LowStockResponse>('/batteries/low-stock', {
      params: { filter }
    }),

  export: (searchQuery?: string) =>
    apiClient.get('/batteries/export', {
      params: searchQuery ? { q: searchQuery } : {},
      responseType: 'blob'
    }),

  downloadExcel: async (searchQuery?: string) => {
    const response = await batteriesAPI.export(searchQuery);
    const blob = response.data;
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    const filename = searchQuery
      ? `battery-search-${searchQuery}-${Date.now()}.xlsx`
      : `battery-inventory-${Date.now()}.xlsx`;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  },
};